// Generated by Melange

import * as ReactRouter from "@tanstack/react-router";
import * as Caml_option from "melange.js/caml_option.jsx";
import * as Fx from "../fx/fx.jsx";
import * as Pages__ArtistPage from "../pages/artistPage.jsx";
import * as $$Promise from "../promise/promise.jsx";
import * as Routes__LayoutRoute from "./layoutRoute.jsx";
import * as Shared__CoverArt from "../shared/coverArt.jsx";
import * as Shared__MediaHeader from "../shared/mediaHeader.jsx";
import * as Shared__RouterUtils from "../shared/routerUtils.jsx";
import * as Stdlib__Fun from "melange/fun.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import * as Stdlib__Result from "melange/result.jsx";
import * as StoreFx__FetchArtistInfo from "../storeFx/fetchArtistInfo.jsx";
import * as StoreFx__FetchOneArtist from "../storeFx/fetchOneArtist.jsx";
import * as StoreFx__FetchTopSongs from "../storeFx/fetchTopSongs.jsx";
import * as JsxRuntime from "react/jsx-runtime";

function loader(param) {
  const artistId = param.params.artistId;
  const store = param.context.store;
  const arg = {
    store: store
  };
  const fetchOnePromise = (function (param) {
    return Fx.runAsync(param, arg);
  })(StoreFx__FetchOneArtist.make(artistId)).then(function (result) {
    Stdlib__Result.get_ok(result);
    const state = store.getState();
    return Promise.resolve(Stdlib__Option.get(Caml_option.undefined_to_opt(state.artists.byId.get(artistId))));
  });
  const arg$1 = {
    store: store
  };
  const artistInfoPromise = (function (param) {
    return Fx.runAsync(param, arg$1);
  })(StoreFx__FetchArtistInfo.make(artistId)).then(function (result) {
    return Promise.resolve(Stdlib__Result.get_ok(result));
  });
  const deferredArtistInfo = artistInfoPromise.then(function (param) {
    const state = store.getState();
    return Promise.resolve(Stdlib__Option.get(Caml_option.undefined_to_opt(state.artists.artistInfoById.get(artistId))));
  });
  const deferredSimilarArtists = artistInfoPromise.then(function (param) {
    const state = store.getState();
    return Promise.resolve(Stdlib__Option.get(Caml_option.undefined_to_opt(state.artists.similarArtistsById.get(artistId))));
  });
  const state = store.getState();
  return $$Promise.Monad_syntax.let$star(Stdlib__Option.fold(fetchOnePromise, (function (prim) {
    return Promise.resolve(prim);
  }), Caml_option.undefined_to_opt(state.artists.byId.get(artistId))), (function (initialArtist) {
    const state = store.getState();
    const credentials = Stdlib__Option.get(state.auth.credentials);
    Shared__CoverArt.preload(credentials, initialArtist.coverArt, Shared__MediaHeader.media_header_cover_art_sizes);
    return $$Promise.Monad_syntax.let$star(fetchOnePromise, (function (param) {
      const state = store.getState();
      const initialAlbumIds = Stdlib__Option.get(Caml_option.undefined_to_opt(state.artists.albumIdsByArtistId.get(artistId)));
      const deferredTopSongIds = Fx.runAsync(StoreFx__FetchTopSongs.make(initialArtist.name), {
        store: store
      }).then(function (result) {
        Stdlib__Result.get_ok(result);
        const state = store.getState();
        return Promise.resolve(Stdlib__Option.get(Caml_option.undefined_to_opt(state.artists.topSongIdsByArtistName.get(initialArtist.name))));
      });
      return Promise.resolve({
        deferredArtistInfo: deferredArtistInfo,
        deferredSimilarArtists: deferredSimilarArtists,
        deferredTopSongIds: deferredTopSongIds,
        initialAlbumIds: initialAlbumIds,
        initialArtist: initialArtist
      });
    }));
  }));
}

function Artist$pendingComponent(Props) {
  const params = ReactRouter.getRouteApi("/_layout/artist/$artistId").useParams();
  return JsxRuntime.jsx(Pages__ArtistPage.make, {
    params: params
  });
}

function Artist$component(Props) {
  const routeApi = ReactRouter.getRouteApi("/_layout/artist/$artistId");
  const params = routeApi.useParams();
  const match = routeApi.useLoaderData();
  return JsxRuntime.jsx(Pages__ArtistPage.make, {
    deferredArtistInfo: match.deferredArtistInfo,
    deferredSimilarArtists: match.deferredSimilarArtists,
    deferredTopSongIds: match.deferredTopSongIds,
    initialAlbumIds: match.initialAlbumIds,
    initialArtist: match.initialArtist,
    params: params
  });
}

const route = ReactRouter.createRoute({
  beforeLoad: Shared__RouterUtils.requireSubsonicCredentials,
  component: Artist$component,
  getParentRoute: (function (param) {
    return Stdlib__Fun.$$const(Routes__LayoutRoute.route, param);
  }),
  loader: loader,
  path: "/artist/$artistId",
  pendingComponent: Artist$pendingComponent
});

const pendingComponent = Artist$pendingComponent;

const component = Artist$component;

export {
  loader,
  pendingComponent,
  component,
  route,
}
/* route Not a pure module */
